import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Kicker, H2 } from './ui/Typography';
export function WhoItsForSection() {
  const archetypes = [{
    title: 'THE TIME STARVED',
    desc: '5-10 hrs/week, needs income that runs without babysitting'
  }, {
    title: 'THE SKILL RICH',
    desc: 'Already good at something, wants AI to multiply expertise'
  }, {
    title: 'THE SCRAPPY STARTER',
    desc: 'Full of energy, will hustle for first client'
  }, {
    title: 'THE BUILDER',
    desc: 'Likes systems and automations, thinks in workflows'
  }];
  return <Section hasOrb={false} data-id="element-202">
      <Kicker data-id="element-203">IS THIS YOU?</Kicker>
      <H2 data-id="element-204">BUILT FOR 4 KINDS OF PEOPLE.</H2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16 mb-12" data-id="element-205">
        {archetypes.map((arch, i) => <Card key={i} delay={i * 0.1} className="flex items-start gap-4" data-id="element-206">
            <div className="w-3 h-3 rounded-full bg-brand mt-2 shrink-0 shadow-glow" data-id="element-207" />
            <div data-id="element-208">
              <h3 className="font-archivo text-xl uppercase tracking-tight mb-2" data-id="element-209">
                {arch.title}
              </h3>
              <p className="text-ink-dim" data-id="element-210">{arch.desc}</p>
            </div>
          </Card>)}
      </div>

      <motion.p initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true,
      amount: 0.01
    }} transition={{
      delay: 0.4
    }} className="text-ink-dim text-center max-w-2xl mx-auto italic" data-id="element-211">
        If you see yourself in any of these, you're in the right place. The book
        will show you which of the 7 paths matches your profile.
      </motion.p>
    </Section>;
}